<template>
  <section class="document-details">
    <header class="header-layout">
      <mo-pageheader>
		<template slot="title">
          {{ $t('title.documentEdit') }}: <span
            v-if="document && document.Aaa && document.Tecdoc"
            class="label"
          >{{ document.Aaa.brand }} {{ document.Aaa.model }} - {{ document.Tecdoc.date_min }} ({{ document.Document.view }} {{ document.Document.view == 1 ? `vue` : `vues` }} - {{ document.Document.matriculation }})</span>
        </template>
        <template slot="action">
          <div class="buttons-container flex flex-end">
             <ba-button
              type="button"
              class="danger"
              @click.native="$modal.show('report-document-details')"
            >
              {{ $t('action.reportDocument') }}
            </ba-button>
            <ba-button
              v-if="selectedDocument && accessRestreint === 1"
              type="button"
              class="btn-action primary"
              @click.native="handleGoBackAccesRestreint"
            >
              {{ $t('action.return') }}
            </ba-button>
            <ba-button
              v-else-if="selectedDocument"
              type="button"
              class="btn-action primary"
              @click.native="handleGoBack"
            >
              {{ $t('action.return') }}
            </ba-button>
            <ba-button
              v-else
              type="button"
              class="btn-action primary"
              @click.native="$router.go(-1)"
            >
              {{ $t('action.return') }}
            </ba-button>
          </div>
        </template>
      </mo-pageheader>
    </header>

    <main class="main-layout">
      <form>
        <ba-card>
          <template slot="header">
            <span>{{ $t('sectionTitle.informationAaa') }}</span>
          </template>
          <template>
            <div class="cols">
              <div class="col-4">
                <ba-input type="text" label="Identifiant de la fiche" v-model="id" disabled></ba-input>
              </div>
              <div class="col-4">
                <ba-input type="text" label="Energie" v-model="aaa_energy" disabled></ba-input>
              </div>
              <div class="col-4">
                <ba-input type="text" label="Boîte de vitesses" v-model="gearbox" disabled></ba-input>
              </div>
              <div class="col-4">
                <ba-input type="text" label="Nombre cylindres" v-model="aaa_cylinder_number" disabled></ba-input>
              </div>
              <div class="col-4">
                <ba-input type="text" label="Marque" v-model="aaa_brand" disabled></ba-input>
              </div>
              <div class="col-4">
                <ba-input type="text" label="Cylindré" v-model="aaa_cylinder" disabled></ba-input>
              </div>
              <div class="col-4">
                <ba-input type="text" label="Nombre de vitesse" v-model="gear_number" disabled></ba-input>
              </div>
              <div class="col-4">
                <ba-input type="text" label="Moteur turbo" v-model="turbocharger" disabled></ba-input>
              </div>
              <div class="col-4">
                <ba-input type="text" label="Modèle" v-model="aaa_model" disabled></ba-input>
              </div>
              <div class="col-4">
                <ba-input type="text" label="Nombre soupapes" v-model="valve_number" disabled></ba-input>
              </div>
              <div class="col-4">
                <ba-input type="text" label="Carrosserie" v-model="carbody" disabled></ba-input>
              </div>
              <div class="col-4">
                <ba-input type="text" label="Mode injection" v-model="injection_mode" disabled></ba-input>
              </div>
              <div class="col-4">
                <ba-input type="text" label="Version" v-model="version" disabled></ba-input>
              </div>
              <div class="col-4">
                <ba-input type="text" label="Puissance CV" v-model="aaa_steam_power" disabled></ba-input>
              </div>
              <div class="col-4">
                <ba-input type="text" label="Type propulsion" v-model="propulsion" disabled></ba-input>
              </div>
            </div>
          </template>
        </ba-card>

        <ba-card>
          <template slot="header">
            <span>{{ $t('sectionTitle.informationTecdoc') }}</span>
          </template>
          <template>
            <div class="cols">
              <div class="col-4">
                <ba-input type="text" label="Ktype" v-model="ktype" disabled></ba-input>
              </div>
              <div class="col-4">
                <ba-input type="text" label="Energie" v-model="tecdoc_energy" disabled></ba-input>
              </div>
              <div class="col-4">
                <section class="basic-date">
                  <label>{{ $t('text.dateMin') }}</label>
                  <datepicker
                    label="Date min"
                    type="date"
                    name="date"
                    format="01/MM/yyyy"
                    class="basic-datepicker"
                    :disabled="true"
                    :minimum-view="'month'"
                    :maximum-view="'month'"
                    :language="language"
                    v-model="date_min"
                  >
                  </datepicker>
                </section>
              </div>
              <div class="col-4">
                <ba-input type="text" label="Marque" v-model="tecdoc_brand" disabled></ba-input>
              </div>
              <div class="col-4">
                <ba-input type="text" label="Cylindré" v-model="tecdoc_cylinder" disabled></ba-input>
              </div>
              <div class="col-4">
                <section class="basic-date">
                  <label>{{ $t('text.dateMax') }}</label>
                  <datepicker
                    label="Date max"
                    type="date"
                    name="date"
                    format="01/MM/yyyy"
                    class="basic-datepicker"
                    :disabled="true"
                    :minimum-view="'month'"
                    :maximum-view="'month'"
                    :language="language"
                    v-model="date_max"
                  >
                  </datepicker>
                </section>
              </div>
              <div class="col-4">
                <ba-input type="text" label="Modèle" v-model="tecdoc_model" disabled></ba-input>
              </div>
              <div class="col-4">
                <ba-input type="text" label="Nombre cylindres" v-model="tecdoc_cylinder_number" disabled></ba-input>
              </div>
              <div class="col-4">
                <ba-input type="text" label="Type" v-model="type" disabled></ba-input>
              </div>
              <div class="col-4">
                <ba-input type="text" label="Puissance CV" v-model="computedFiscal" disabled></ba-input>
              </div>
            </div>
          </template>
        </ba-card>

        <div class="cards-container flex-stretch flex-space">
          <ba-card class="cnit-mine-card">
            <template slot="header">
              <span>{{ $t('sectionTitle.cnitMine') }}</span>
            </template>
            <template>
              <div class="cnit-mine-ctn">
                <div class="cnit-list">
                  <table>
                    <thead>
                      <tr>
                        <th>Type</th>
                        <th>Immatriculation</th>
                        <th>Label</th>
                        <th>VIN</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="cnit in computedCnitMine" :key="`check-cnit-${cnit.id}`">
                        <td class="type">{{ cnit.type }}</td>
                        <td class="matriculation">{{ cnit.matriculation }}</td>
                        <td class="label">{{ cnit.label }}</td>
                        <td>{{ cnit.vin }}</td>
<!--                         <td class="right">
                          <span v-if="!cnit.is_valid" class="icon" @click="handleValidateCnitMine(cnit)"><ab-icon class="checkmark" icon="checkmark"></ab-icon></span>
                          <span class="icon" @click="$modal.show('remove-cnit-mine', { id: cnit.id, label: cnit.label, type: 'cnit' })"><ab-icon class="bin" icon="bin"></ab-icon></span>
                        </td> -->
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </template>
          </ba-card>
          <div class="div-accessrestreint" v-if="accessRestreintOriMot === 1">
              <span class="btn-action primary btn-accessrestreint"  @click="clickBtnAccessReistreint('OriMot')">{{ $t('sectionTitle.motorOrigin') }}</span>
          </div>
          <ba-card class="observation-card" v-else>
            <template slot="header">
              <span>{{ $t('sectionTitle.motorOrigin') }}</span>
            </template>
            <template>
              <div class="container">
                <ba-input type="text" label="Type moteur" v-model="motor_type" disabled></ba-input>
                <ba-input type="text" label="Adaptabilité moteur" v-model="motor_adaptability" disabled></ba-input>
                <ba-textarea class="observation" label="Observation" v-model="motor_observation" disabled></ba-textarea>
                <div >
                    <table>
                    <thead>
                        <tr>
                          <th style="text-align:left">
                            Images
                          </th>
                          <th />
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="img in img_motor">
                          <td
                            style="cursor:pointer;"
                            @click="openModalPreview(img)"
                          >
                            {{ img.label }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div style="flex: 1;">
                    <table>
                      <thead>
                        <tr>
                          <th>Documents</th>
                          <th />
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="doc in doc_motor">
                          <td
                            style="cursor:pointer;"
                            @click="openDocument(doc)"
                          >
                            {{ doc.label }}
                          </td>
                        </tr>
                      </tbody>
                    </table>

                   
                </div>
              </div>
            </template>
          </ba-card>
          <div class="div-accessrestreint" v-if="accessRestreintOriBv === 1">
              <span class="btn-action primary btn-accessrestreint"  @click="clickBtnAccessReistreint('OriBv')">{{ $t('sectionTitle.gearboxOrigin') }}</span>
          </div>
          <ba-card class="observation-card" v-else>
            <template slot="header">
              <span>{{ $t('sectionTitle.gearboxOrigin') }}</span>
            </template>
            <template>
              <div class="container">
                <ba-input type="text" label="Type boîte" v-model="gearbox_type" disabled></ba-input>
                <ba-input type="text" label="Adaptabilité boîte" v-model="gearbox_adaptability" disabled></ba-input>
                <ba-textarea class="observation" label="Observation" v-model="gearbox_observation" disabled></ba-textarea>
                <div >
                    <table>
                     <thead>
                        <tr>
                          <th style="text-align:left">
                            Images
                          </th>
                          <th />
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="img in img_gearbox">
                          <td
                            style="cursor:pointer;"
                            @click="openModalPreview(img)"
                          >
                            {{ img.label }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div style="flex: 1;">
                    <table>
                      <thead>
                        <tr>
                          <th>Documents</th>
                          <th />
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="doc in doc_gearbox">
                          <td
                            style="cursor:pointer;"
                            @click="openDocument(doc)"
                          >
                            {{ doc.label }}
                          </td>
                        </tr>
                      </tbody>
                    </table>

                </div>
              </div>
            </template>
          </ba-card>
		  
        </div>
        <div class="buttons-container flex flex-end">
		<!-- handleGoBack $router.go(-1) -->
            <ba-button type="button" class="btn-action primary" @click.native="handleGoBackAccesRestreint" v-if="selectedDocument && accessRestreint === 1">{{ $t('action.return') }}</ba-button>
            <ba-button type="button" class="btn-action primary" @click.native="handleGoBack" v-else-if="selectedDocument">{{ $t('action.return') }}</ba-button>
            <ba-button type="button" class="btn-action primary" @click.native="$router.go(-1)" v-else>{{ $t('action.return') }}</ba-button>
        </div>
      </form>
    </main>
      
        <!-- img/Motor/Gearbox PREVIEW -->
    <modal ref="pimg" class="modal"  :height="'auto'"   :shiftX="0"  :shiftY="0" :width="widthscreen"  name="preview-img"  >
      <ba-card>
        <template slot="header">
          <span>{{ previewLabel }} </span>
        </template>
        <template>
         <img  ref="imgr" :style="stylePreview"  :src="imgSelected" @load="recenterModal" />
        </template>
        <template slot="footer">
          <div class="buttons-container flex flex-end">
            <ba-button class="primary" @click.native="closeModalImgPreview">{{ $t('action.close') }}</ba-button>
          </div>
        </template>
      </ba-card>
    </modal>

    <!-- DOCUMENT REPORT MODAL -->
    <!-- Need to change modal name, or it will show the modal from Create or Edit view -->
    <modal class="modal" name="report-document-details" width="376px">
      <ba-card>
        <template slot="header">
          <span>Signalement fiche article</span>
        </template>
        <template>
          <p>Êtes-vous sûrs de vouloir signaler cette fiche à l'administrateur ?</p>
          <ba-textarea class="report-textarea" label="Commentaire" :maxlength="255" :rows="4" v-model="documentReport.comment"></ba-textarea>
        </template>
        <template slot="footer">
          <div class="buttons-container flex flex-end">
            <ba-button type="button" class="primary" @click.native="$modal.hide('report-document-details')">Non</ba-button>
            <ba-button class="primary" @click.native="handleReportDocument">Oui</ba-button>
          </div>
        </template>
      </ba-card>
    </modal>

  </section>
</template>

<script>
import { AbIcon, BaButton, BaCard, BaInput, BaTextarea } from '@ab/basic-components';
import MoPageheader from '@/components/layout/nav/mo-pageheader.vue';
import { mapState } from 'vuex';

import Datepicker from "vuejs-datepicker";
import {fr} from "vuejs-datepicker/dist/locale";

export default {
  name: 'DocumentDetails',
  components: {
    AbIcon,
    BaButton,
    BaCard,
    BaInput,
    BaTextarea,
    Datepicker,
    MoPageheader
  },
  props: {
    documentProp: [String, Number],
  },
  async mounted() {
    this.$store.commit('setSpinner', true);
    
    this.widthscreen = window.innerWidth - 50;
    this.stylePreview = "maxWidth:"+ this.widthscreen+"px;maxHeight:"+(window.innerHeight - 150)+"px;";

    const id = this.documentProp ? this.selectedDocument : this.$route.params.id;
    const documentData =  await this.$store.dispatch('getDocument', id);
	this.accessRestreintOriMot  = await this.$store.dispatch('getAccessRetreint', { typeRch: 'fiche_article', brand: this.aaa_brand, model: this.aaa_model, document_id: this.id });	
	this.accessRestreintOriBv = this.accessRestreintOriMot
	this.$store.commit('setSpinner', false);    
	this.accessRestreint = await this.$store.dispatch('getAccessRetreint', { typeRch: '' });
        
     
        this.img_motor = documentData.Image_Motor;
		this.img_gearbox = documentData.Image_Gearbox;
		this.doc_motor = documentData.Document_Motor;
		this.doc_gearbox = documentData.Document_Gearbox;

  },
  data() {
    return {
      selectedDocument: this.documentProp,

      aaa_brand: '',
      aaa_cylinder: '',
      aaa_cylinder_number: '',
      aaa_energy: '',
      aaa_model: '',
      aaa_steam_power: '',
      carbody: '',
      cnit_list: '',
      date_max: '',
      date_min: '',
      gearbox: '',
      gearbox_type: '',
      gearbox_adaptability: '',
      gearbox_observation: '',
      gear_number: '',
      id: '',
      injection_mode: '',
      ktype: '',
      widthscreen:1000,
      language: fr,
      mine_list: '',
      motor_type: '',
      motor_adaptability: '',
      motor_observation: '',
      propulsion: '',
      tecdoc_steam_power: '',
      tecdoc_energy: '',
      tecdoc_brand: '',
      tecdoc_cylinder: '',
      tecdoc_cylinder_number: '',
      tecdoc_model: '',
      type: '',
      turbocharger: '',
      valve_number: '',
      version: '',
      img_motor:[],
      img_gearbox:[],
	  doc_motor: [],
      doc_gearbox: [],
      imgSelected:'',
      previewLabel:'',
      label_img:'',
      stylePreview:"maxWidth:100%",
      documentReport: {
        comment: ''
      },
	  accessRestreint: '1',
	  accessRestreintOriBv: '',
	  accessRestreintOriMot: '',
    }
  },
  computed: {
        ...mapState({ document: state => state.documents.document }),
	...mapState({ request: state => state.requests.request }),
    computedFiscal() {
      if (this.tecdoc_steam_power) { return Math.round(this.tecdoc_steam_power * 1.341); }
      return '';
    },
    computedCnitMine() {
      const array = this.cnit_list.concat(this.mine_list);
      if (Array.isArray(array)) {
        array.sort(function(item1, item2) {
          // First sort if first element is not valid
          if (!item1.is_valid && item2.is_valid) { return 1; }
          if (item1.is_valid && !item2.is_valid) { return -1; }
          // Then sort by matriculation name
          if (item1.matriculation > item2.matriculation) { return 1; }
          if (item1.matriculation < item2.matriculation) { return -1; }

        });
      }
      return array;
    },

  },
  methods: {
      openModalPreview(img) {
      const baseApi = process.env.VUE_APP_ROOT_API;
      this.imgSelected = `${baseApi}${img.path}`;
      this.previewLabel = img.label;
      this.$refs.pimg.shift.left = 0;
      this.$refs.pimg.shift.top = 0;
      this.$refs.pimg.modal.width = this.widthscreen;
      this.$refs.pimg.modal.height = window.innerHeight - 150;
      this.$modal.show('preview-img');
    },
    closeModalImgPreview() {
      this.$modal.hide('preview-img');
    },
    openDocument(doc) {
      const baseApi = process.env.VUE_APP_ROOT_API;
      const docUrl = `${baseApi}${doc.path}`;

      const fileExtension = doc.path.split('.').pop().toLowerCase();

      if (fileExtension === 'pdf') {
        window.open(docUrl, '_blank');
      } else {
        const link = document.createElement('a');
        link.href = docUrl;
        link.download = doc.label || doc.path.split('/').pop();
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    recenterModal() {
      this.$refs.pimg.shift.left = 0.5;
      if (this.$refs.imgr.clientWidth < this.widthscreen) {
        this.$refs.pimg.modal.width = this.$refs.imgr.clientWidth;
      } else {
        this.$refs.pimg.modal.width = this.widthscreen;
      }
    },

    clickBtnAccessReistreint(btn) {
	  btn === 'OriBv' ? this.accessRestreintOriBv = 0 : this.accessRestreintOriMot = 0
      this.$store.dispatch('setHistoAccess', { typeRch: 'fiche_article', brand: this.aaa_brand, model: this.aaa_model, document_id: this.id });	
	},
    /* -- Modal handling --*/
    handleGoBack() {
      this.$emit('close')
    },
	handleGoBackAccesRestreint() {
	///////////////////////////////////////////////////////
	// en accès restreint soit le dossier est sauvegarde // 
	// soit en creation                                  // 
	///////////////////////////////////////////////////////
	  let url = this.$route.fullPath
	  let pos = url.lastIndexOf('create')
	  if (pos === -1) {
        this.$router.go(this.$route.fullPath)
	  } else {
	   this.$emit('close')	  
	  }
	},
    async handleReportDocument() {
      if (this.id) {
        const data = await this.$store.dispatch('reportDocument', {
          document_id: this.id,
          comment: this.documentReport.comment
        });

        if (data && data.success) { this.$store.dispatch('displaySnackbar', { text: this.$t('snackbar.documentMailReport') }); }
        else { this.$store.dispatch('displaySnackbar', { text: this.$t('error.anErrorOccurred'), mode: 'error' }); }
      }
      this.$modal.hide('report-document-details');
    },
  },
  watch: {
    document(newDocument, oldDocument) {
      this.aaa_brand = newDocument.Aaa.brand;
      this.aaa_cylinder = newDocument.Aaa.cylinder;
      this.aaa_cylinder_number = newDocument.Aaa.cylinder_number;
      this.aaa_energy = newDocument.Aaa.energy;
      this.aaa_model = newDocument.Aaa.model;
      this.aaa_steam_power = newDocument.Aaa.steam_power;
      this.carbody = newDocument.Aaa.carbody;
      this.cnit_list = newDocument.Cnit;
      this.cylinder_number = newDocument.Tecdoc.cylinder_number;
      this.date_max = newDocument.Tecdoc.date_max ? new Date(newDocument.Tecdoc.date_max) : "";
      this.date_min = newDocument.Tecdoc.date_min ? new Date(newDocument.Tecdoc.date_min) : "";
      this.gear_number = newDocument.Aaa.gear_number;
      this.gearbox = newDocument.Aaa.gearbox;
      this.gearbox_adaptability = newDocument.Gearbox_adaptability.map(e => e.label).join(', ');
      this.gearbox_observation = newDocument.Document.gearbox_observation;
      this.gearbox_type = newDocument.Gearbox_type.map(e => e.label).join(', ');
      this.id = newDocument.Document.id;
      this.injection_mode = newDocument.Aaa.injection_mode;
      this.ktype = newDocument.Aaa.ktype;
      this.mine_list = newDocument.Mine_type;
      this.motor_adaptability = newDocument.Motor_adaptability.map(e => e.label).join(', ');
      this.motor_observation = newDocument.Document.motor_observation;
      this.motor_type = newDocument.Motor_type.map(e => e.label).join(', ');
      this.propulsion = newDocument.Aaa.propulsion;
      this.tecdoc_brand = newDocument.Tecdoc.brand;
      this.tecdoc_cylinder = newDocument.Tecdoc.cylinder;
      this.tecdoc_cylinder_number = newDocument.Tecdoc.cylinder_number;
      this.tecdoc_energy = newDocument.Tecdoc.energy;
      this.tecdoc_model = newDocument.Tecdoc.model;
      this.tecdoc_steam_power = newDocument.Tecdoc.steam_power;
      this.type = newDocument.Tecdoc.type;
      this.turbocharger = newDocument.Aaa.turbocharger;
      this.valve_number = newDocument.Aaa.valve_number;
      this.version = newDocument.Aaa.version * newDocument.Aaa.cylinder_number;

      // Add selected key into cnit_list & mine_list for checkboxes
      this.cnit_list = newDocument.Cnit.map(e => ({ ...e, type: 'Cnit' }));
      this.mine_list = newDocument.Mine_type.map(e => ({ ...e, type: 'Mine' }));
    }
  }
};
</script>
<style>
.div-accessrestreint {
  margin-right: 110px;
}
</style>

<style src="@/assets/styles/documents.css"></style>
<style src="@/assets/styles/datepickers.css"></style>
<style src="@/assets/styles/modals.css"></style>
<style src="@/assets/styles/tabs.css"></style>
